export default "__VITE_ASSET__JXEftJlJ__ 500w";